import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import './Login.css';

export default function Login() {
    const { login } = useAuth();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSubmitting(true);
        try {
            await login(username, password);
        } catch (err) {
            setError(err.message);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="login-page">
            <form className="login-form" onSubmit={handleSubmit}>
                <h1 className="login-title">MAST</h1>
                <p className="login-subtitle">Maritime Analysis & Scoring Tool</p>
                {error && <div className="login-error">{error}</div>}
                <label className="login-label">
                    Username
                    <input className="login-input" type="text" value={username}
                        onChange={e => setUsername(e.target.value)} autoFocus required />
                </label>
                <label className="login-label">
                    Password
                    <input className="login-input" type="password" value={password}
                        onChange={e => setPassword(e.target.value)} required />
                </label>
                <button className="login-btn" type="submit" disabled={submitting}>
                    {submitting ? 'Signing in�' : 'Sign In'}
                </button>
            </form>
        </div>
    );
}